import { isProduction } from 'bones/utils/environment';

export const getTestId = (id: string, idx?: number) =>
  isProduction() && id ? `${idx}` : id;

export type TestId = string | ((...args: any[]) => string);
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface TestIds extends Record<string, TestId | TestIds> {}

export const processTestIds = (
  obj: TestIds,
  separator = '.',
  prefix?: string
) => {
  Object.entries(obj).forEach(([key, value]) => {
    const tag = prefix ? `${prefix}${separator}${key}` : key;
    if (typeof value === 'object') {
      processTestIds(value, separator, tag);
      return;
    }

    const testId = tag.replace(
      /[A-Z]/g,
      (letter) => `${separator}${letter.toLowerCase()}`
    );
    if (typeof value === 'function') {
      // eslint-disable-next-line no-param-reassign
      obj[key] = (...args: any[]) => `${testId}${separator}${value(...args)}`;
    } else {
      // eslint-disable-next-line no-param-reassign
      obj[key] = testId;
    }
  });
};
